import { axiosGet, axiosPatch, axiosPost, baseURL_V2 } from "../axois_V2/axoisWithAuthV2";
import { throwError } from "../utils/error";

export interface LoginResponse {
    success: boolean;
    message: string;
    data: {
        token: string;
    };
}

export const login = async (
    payload: { email: string; password: string }
): Promise<LoginResponse> => {
    try {
        const res = await axiosPost(`${baseURL_V2}/login`, payload);

        if (res instanceof Error) {
            throw res;
        }

        return res;
    } catch (error) {
        throw error;
    }
};

export const getMeUser = async () => {
    try {
        const res = await axiosGet(`${baseURL_V2}/me`);
        return res?.data;
    } catch (error) {
        throw error;
    }
};


export const DonorSendOtp_V2 = async (payload: { email: string; name?: string; phone?: number }) => {
    try {
        const res = await axiosPost(`${baseURL_V2}/send-login-otp`, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
};

// Verify OTP and login
export const Donorlogin_V2 = async (payload: { email: string; otp: number }) => {
    try {
        const res = await axiosPost(`${baseURL_V2}/verify-login-otp`, payload);
        return res;
    } catch (error) {
        throw error;
    }
};

// Verify OTP and login
export const DonorRegister_V2 = async (payload: { email: string; phone: number, name: string }) => {
    try {
        const res = await axiosPost(`${baseURL_V2}/register-donor`, payload);
        return res;
    } catch (error) {
        throw error;
    }
};

export const updateUserProfile = async (data: {
    name?: string;
    phone?: string;
    pan_number?: string;
    userType?: string;
    position?: string;
    organizationPartner?: boolean;
}) => {
    const response = await axiosPatch(`${baseURL_V2}/update-details`, data);
    return response;
};

export const forgotPassword_V2 = async ({ email }: { email: string }) => {
    try {
        const res = await axiosPost(`${baseURL_V2}/forgot-password`, { email });
        return res;
    } catch (error) {
        throwError(error);
    }
}

export const changePassword_V2 = async (payload: { oldPassword: string, newPassword: string }) => {
    try {
        const res = await axiosPost(`${baseURL_V2}/change-password`, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
}
